module.exports = __webpack_public_path__ + "static/media/copy.e631f1e0.svg";